import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  UserIcon,
  BriefcaseIcon,
} from "@heroicons/react/24/outline";

// components
import { UserAvatar } from "../../components/commons/user.avatar";
import { StarRating } from "../../components/commons/star.rating";
import { SectionSubHeader } from "../../components/layouts/section.subheader";

// reducers
import { fetchJobServiceDetails } from "../../stores/jobs";

// utilities
import { classNames, openAssetKeyNewTab } from "../../utilities";

export const ScreenJobDetailsPartner = () => {

  // hooks
  const dispatch = useDispatch();
  const { details } = useSelector(context => context.jobs);
  const { technician, technician_rating } = details;


  if (!details.technician) {
    return (
      <div className="h-[80vh] flex flex-col justify-center items-center bg-white rounded-2xl shadow-md">
        <p className="text-4xl text-slate-400 text-bold">Looking for Strategic Partner</p>
      </div>
    )
  }

  return (
    <div className="pb-[10vh] bg-white rounded-2xl shadow-md">

      {/* PERSONAL INFORMATION */}
      <div className="py-8 px-4 border-b border-slate-200">
        <SectionSubHeader title={'Personal Information'} Icon={UserIcon} />
        <div className="grid grid-cols-4 gap-4 divide-x divide-slate-200">
          <div className="py-4 px-2 col-span-2 flex justify-start items-start">
            <UserAvatar url={technician.individual.picture.key} />
          </div>

          <div className="px-2 col-span-2">
            <SideKeyValue label={'Name'} value={technician.individual.name} />
            <SideKeyValue label={'Identification Number'} value={technician.individual.identification_number} />
            <SideKeyValue label={'Phone Number'} value={technician.individual.phone_number} />
            <SideKeyValue label={'Email'} value={technician.individual.email} />
            <SideKeyValue label={'Gender'} value={technician.individual.gender} />
            <SideKeyValue label={'Race'} value={technician.individual.race} />
            <SideKeyValue 
              label={'Rating'} 
              value={
                <StarRating rating={technician_rating && technician_rating.count > 0 ? technician_rating.total/technician_rating.count : 0} />
              } 
            />
          </div>
        </div>
      </div>

      {/* WORKING EXPERIENCE */}
      <div className="py-8 px-4 border-b border-slate-200">
        <SectionSubHeader title={'Working Experience'} Icon={BriefcaseIcon} />
        <div className="grid grid-cols-6 gap-4 divide-x divide-slate-200">
          <div className="px-2 col-span-3">
            <SideKeyValue label={'Type'} value={'Electrical Wiring Competency'} />
            <SideKeyValue 
              label={'Highest Level Certification'} 
              value={technician.electrical_competency.electrical_wiring.not_applicable ? 'Not certified' : technician.electrical_competency.electrical_wiring.highest_level} 
            />
            {technician.electrical_competency.electrical_wiring.years_of_experience && 
              <SideKeyValue 
                label={'Years of Experience'} 
                value={technician.electrical_competency.electrical_wiring.years_of_experience.replace(/_/gi, ' ')} 
              />
            }
            <SideKeyValue 
              label={'Certificate'} 
              value={
                <div
                  onClick={() => openAssetKeyNewTab(technician.electrical_competency.electrical_wiring.file.key)}
                >
                  <p className="underline text-blue-400 hover:cursor-pointer">Click Here</p>
                </div>
              } 
            />
          </div>

          <div className="px-2 col-span-3">
            <SideKeyValue label={'Type'} value={'Chargeman Competency'} />
            <SideKeyValue 
              label={'Highest Level Certification'} 
              value={technician.electrical_competency.chargeman.not_applicable ? 'Not certified' : technician.electrical_competency.chargeman.highest_level} 
            />
            {technician.electrical_competency.chargeman.years_of_experience && 
              <SideKeyValue 
                label={'Years of Experience'} 
                value={technician.electrical_competency.chargeman.years_of_experience.replace(/_/gi, ' ')} 
              />
            }
            <SideKeyValue 
              label={'Certificate'} 
              value={
                <div
                  onClick={() => openAssetKeyNewTab(technician.electrical_competency.chargeman.file.key)}
                >
                  <p className="underline text-blue-400 hover:cursor-pointer">Click Here</p>
                </div>
              } 
            />
          </div>
        </div>
      </div>

    </div>
  );
};

const HeaderKeyValue = ({label, value}) => {
  return (
    <div className="pr-8">
      <h4 className="text-sm text-slate-500 font-normal">{label}</h4>
      <p className="text-base text-slate-800 font-semibold">{value}</p>
    </div>
  )
}


const SideKeyValue = ({label, value}) => {
  return (
    <div className="pt-4 grid grid-cols-8">
      <h4 className="col-span-4 text-sm text-slate-500 font-normal">{label}</h4>
      <span className="col-span-4 text-sm text-slate-900 font-medium text-left">{value}</span>
    </div>
  )
}

const FilterSection = ({title, selected, onSelect = () => {}}) => {
  return (
    <div className={classNames(
      "px-8 py-1 mr-4 border border-slate-200 rounded-xl shadow-sm hover:cursor-pointer",
      selected ? 'bg-primary-500' : 'bg-slate-200',
    )}>
      <p className={classNames(
        "col-span-4 text-sm font-normal",
        selected ? 'text-white': 'text-slate-500'
      )}
      >
        {title}
      </p>
    </div>
  )
}